export default __webpack_public_path__ + "static/media/saldo-azul.192ff8b8.svg";